import { isGuid } from '../../../utils/guid';

const orderRuleActionsMeetsCriteria = (criteria, orderRuleActionsArr) =>
  orderRuleActionsArr.some((orderRuleActions) => {
    return Object.keys(criteria).every((key) => criteria[key] === orderRuleActions[key]);
  });

export const filterActiveRulesWithRuleActions = (rules, orderRuleActionCriteria) =>
  rules.filter(({ active, orderRuleActions }) => active && orderRuleActionsMeetsCriteria(orderRuleActionCriteria, orderRuleActions));

/**
 * @param {object} params
 * @param {string | undefined} params.name
 * @param {string | undefined} params.filterId
 * @param {object} [params.selectedRule]
 * @param {Array<{actionTypeId?: number, paramater?: string | null, intParameter?: number | null, orderRuleActionId?: string | number}>} [params.orderRuleActions]
 * @returns {object} The new automation rule
 */
export const generateNewAutomationRule = ({ name, filterId, selectedRule = {}, orderRuleActions = [] }) => ({
  ...selectedRule,
  name,
  filterId,
  active: true,
  isNew: true,
  orderRuleActions: orderRuleActions.map((action) => ({
    ...action,
    orderRuleActionId: isGuid(action.orderRuleActionId) ? undefined : action.orderRuleActionId,
  })),
});
